import { render, staticRenderFns } from "./CoreCompany.vue?vue&type=template&id=70031513&scoped=true"
import script from "./CoreCompany.vue?vue&type=script&lang=js"
export * from "./CoreCompany.vue?vue&type=script&lang=js"
import style0 from "./CoreCompany.vue?vue&type=style&index=0&id=70031513&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70031513",
  null
  
)

export default component.exports